/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  CertificateAttachment,
  CertificateAttachmentRequest,
  CertificateCreateUpdate,
  CertificateCreateUpdateRequestRequest,
  CertificateList,
  CertificateListResponse,
  CertificatesListParams,
  PatchedCertificateAttachmentRequest,
  PatchedCertificateCreateUpdateRequestRequest
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type certificatesListResponse200 = {
  data: CertificateListResponse
  status: 200
}

export type certificatesListResponseSuccess = (certificatesListResponse200) & {
  headers: Headers;
};
;

export type certificatesListResponse = (certificatesListResponseSuccess)

export const getCertificatesListUrl = (params?: CertificatesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["portfolio_id","property_id"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/certificates/?${stringifiedParams}` : `/api/v1/certificates/`
}

/**
 * Enhanced list method with metadata
 */
export const certificatesList = async (params?: CertificatesListParams, options?: RequestInit): Promise<certificatesListResponse> => {

  return customFetch<certificatesListResponse>(getCertificatesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type certificatesCreateResponse201 = {
  data: CertificateCreateUpdate
  status: 201
}

export type certificatesCreateResponseSuccess = (certificatesCreateResponse201) & {
  headers: Headers;
};
;

export type certificatesCreateResponse = (certificatesCreateResponseSuccess)

export const getCertificatesCreateUrl = () => {




  return `/api/v1/certificates/`
}

/**
 * ViewSet for managing certificates
 */
export const certificatesCreate = async (certificateCreateUpdateRequestRequest: CertificateCreateUpdateRequestRequest, options?: RequestInit): Promise<certificatesCreateResponse> => {

  return customFetch<certificatesCreateResponse>(getCertificatesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(certificateCreateUpdateRequestRequest)
  }
);}


export type certificatesAttachmentsListResponse200 = {
  data: CertificateAttachment[]
  status: 200
}

export type certificatesAttachmentsListResponseSuccess = (certificatesAttachmentsListResponse200) & {
  headers: Headers;
};
;

export type certificatesAttachmentsListResponse = (certificatesAttachmentsListResponseSuccess)

export const getCertificatesAttachmentsListUrl = (certificatePk: string,) => {




  return `/api/v1/certificates/${certificatePk}/attachments/`
}

export const certificatesAttachmentsList = async (certificatePk: string, options?: RequestInit): Promise<certificatesAttachmentsListResponse> => {

  return customFetch<certificatesAttachmentsListResponse>(getCertificatesAttachmentsListUrl(certificatePk),
  {
    ...options,
    method: 'GET'


  }
);}


export type certificatesAttachmentsCreateResponse201 = {
  data: CertificateAttachment
  status: 201
}

export type certificatesAttachmentsCreateResponseSuccess = (certificatesAttachmentsCreateResponse201) & {
  headers: Headers;
};
;

export type certificatesAttachmentsCreateResponse = (certificatesAttachmentsCreateResponseSuccess)

export const getCertificatesAttachmentsCreateUrl = (certificatePk: string,) => {




  return `/api/v1/certificates/${certificatePk}/attachments/`
}

export const certificatesAttachmentsCreate = async (certificatePk: string,
    certificateAttachmentRequest: CertificateAttachmentRequest, options?: RequestInit): Promise<certificatesAttachmentsCreateResponse> => {

  return customFetch<certificatesAttachmentsCreateResponse>(getCertificatesAttachmentsCreateUrl(certificatePk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(certificateAttachmentRequest)
  }
);}


export type certificatesAttachmentsRetrieveResponse200 = {
  data: CertificateAttachment
  status: 200
}

export type certificatesAttachmentsRetrieveResponseSuccess = (certificatesAttachmentsRetrieveResponse200) & {
  headers: Headers;
};
;

export type certificatesAttachmentsRetrieveResponse = (certificatesAttachmentsRetrieveResponseSuccess)

export const getCertificatesAttachmentsRetrieveUrl = (certificatePk: string,
    id: string,) => {




  return `/api/v1/certificates/${certificatePk}/attachments/${id}/`
}

export const certificatesAttachmentsRetrieve = async (certificatePk: string,
    id: string, options?: RequestInit): Promise<certificatesAttachmentsRetrieveResponse> => {

  return customFetch<certificatesAttachmentsRetrieveResponse>(getCertificatesAttachmentsRetrieveUrl(certificatePk,id),
  {
    ...options,
    method: 'GET'


  }
);}


export type certificatesAttachmentsUpdateResponse200 = {
  data: CertificateAttachment
  status: 200
}

export type certificatesAttachmentsUpdateResponseSuccess = (certificatesAttachmentsUpdateResponse200) & {
  headers: Headers;
};
;

export type certificatesAttachmentsUpdateResponse = (certificatesAttachmentsUpdateResponseSuccess)

export const getCertificatesAttachmentsUpdateUrl = (certificatePk: string,
    id: string,) => {




  return `/api/v1/certificates/${certificatePk}/attachments/${id}/`
}

export const certificatesAttachmentsUpdate = async (certificatePk: string,
    id: string,
    certificateAttachmentRequest: CertificateAttachmentRequest, options?: RequestInit): Promise<certificatesAttachmentsUpdateResponse> => {

  return customFetch<certificatesAttachmentsUpdateResponse>(getCertificatesAttachmentsUpdateUrl(certificatePk,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(certificateAttachmentRequest)
  }
);}


export type certificatesAttachmentsPartialUpdateResponse200 = {
  data: CertificateAttachment
  status: 200
}

export type certificatesAttachmentsPartialUpdateResponseSuccess = (certificatesAttachmentsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type certificatesAttachmentsPartialUpdateResponse = (certificatesAttachmentsPartialUpdateResponseSuccess)

export const getCertificatesAttachmentsPartialUpdateUrl = (certificatePk: string,
    id: string,) => {




  return `/api/v1/certificates/${certificatePk}/attachments/${id}/`
}

export const certificatesAttachmentsPartialUpdate = async (certificatePk: string,
    id: string,
    patchedCertificateAttachmentRequest?: PatchedCertificateAttachmentRequest, options?: RequestInit): Promise<certificatesAttachmentsPartialUpdateResponse> => {

  return customFetch<certificatesAttachmentsPartialUpdateResponse>(getCertificatesAttachmentsPartialUpdateUrl(certificatePk,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedCertificateAttachmentRequest)
  }
);}


export type certificatesAttachmentsDestroyResponse204 = {
  data: void
  status: 204
}

export type certificatesAttachmentsDestroyResponseSuccess = (certificatesAttachmentsDestroyResponse204) & {
  headers: Headers;
};
;

export type certificatesAttachmentsDestroyResponse = (certificatesAttachmentsDestroyResponseSuccess)

export const getCertificatesAttachmentsDestroyUrl = (certificatePk: string,
    id: string,) => {




  return `/api/v1/certificates/${certificatePk}/attachments/${id}/`
}

export const certificatesAttachmentsDestroy = async (certificatePk: string,
    id: string, options?: RequestInit): Promise<certificatesAttachmentsDestroyResponse> => {

  return customFetch<certificatesAttachmentsDestroyResponse>(getCertificatesAttachmentsDestroyUrl(certificatePk,id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type certificatesRetrieveResponse200 = {
  data: CertificateList
  status: 200
}

export type certificatesRetrieveResponseSuccess = (certificatesRetrieveResponse200) & {
  headers: Headers;
};
;

export type certificatesRetrieveResponse = (certificatesRetrieveResponseSuccess)

export const getCertificatesRetrieveUrl = (id: string,) => {




  return `/api/v1/certificates/${id}/`
}

/**
 * ViewSet for managing certificates
 */
export const certificatesRetrieve = async (id: string, options?: RequestInit): Promise<certificatesRetrieveResponse> => {

  return customFetch<certificatesRetrieveResponse>(getCertificatesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type certificatesUpdateResponse200 = {
  data: CertificateCreateUpdate
  status: 200
}

export type certificatesUpdateResponseSuccess = (certificatesUpdateResponse200) & {
  headers: Headers;
};
;

export type certificatesUpdateResponse = (certificatesUpdateResponseSuccess)

export const getCertificatesUpdateUrl = (id: string,) => {




  return `/api/v1/certificates/${id}/`
}

/**
 * ViewSet for managing certificates
 */
export const certificatesUpdate = async (id: string,
    certificateCreateUpdateRequestRequest: CertificateCreateUpdateRequestRequest, options?: RequestInit): Promise<certificatesUpdateResponse> => {

  return customFetch<certificatesUpdateResponse>(getCertificatesUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(certificateCreateUpdateRequestRequest)
  }
);}


export type certificatesPartialUpdateResponse200 = {
  data: CertificateCreateUpdate
  status: 200
}

export type certificatesPartialUpdateResponseSuccess = (certificatesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type certificatesPartialUpdateResponse = (certificatesPartialUpdateResponseSuccess)

export const getCertificatesPartialUpdateUrl = (id: string,) => {




  return `/api/v1/certificates/${id}/`
}

/**
 * ViewSet for managing certificates
 */
export const certificatesPartialUpdate = async (id: string,
    patchedCertificateCreateUpdateRequestRequest?: PatchedCertificateCreateUpdateRequestRequest, options?: RequestInit): Promise<certificatesPartialUpdateResponse> => {

  return customFetch<certificatesPartialUpdateResponse>(getCertificatesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedCertificateCreateUpdateRequestRequest)
  }
);}


export type certificatesDestroyResponse204 = {
  data: void
  status: 204
}

export type certificatesDestroyResponseSuccess = (certificatesDestroyResponse204) & {
  headers: Headers;
};
;

export type certificatesDestroyResponse = (certificatesDestroyResponseSuccess)

export const getCertificatesDestroyUrl = (id: string,) => {




  return `/api/v1/certificates/${id}/`
}

/**
 * ViewSet for managing certificates
 */
export const certificatesDestroy = async (id: string, options?: RequestInit): Promise<certificatesDestroyResponse> => {

  return customFetch<certificatesDestroyResponse>(getCertificatesDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type certificatesViolationsRetrieveResponse200 = {
  data: CertificateList
  status: 200
}

export type certificatesViolationsRetrieveResponseSuccess = (certificatesViolationsRetrieveResponse200) & {
  headers: Headers;
};
;

export type certificatesViolationsRetrieveResponse = (certificatesViolationsRetrieveResponseSuccess)

export const getCertificatesViolationsRetrieveUrl = (id: string,) => {




  return `/api/v1/certificates/${id}/violations/`
}

/**
 * Get violations associated with this certificate's car
 */
export const certificatesViolationsRetrieve = async (id: string, options?: RequestInit): Promise<certificatesViolationsRetrieveResponse> => {

  return customFetch<certificatesViolationsRetrieveResponse>(getCertificatesViolationsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type certificatesStatisticsRetrieveResponse200 = {
  data: CertificateList
  status: 200
}

export type certificatesStatisticsRetrieveResponseSuccess = (certificatesStatisticsRetrieveResponse200) & {
  headers: Headers;
};
;

export type certificatesStatisticsRetrieveResponse = (certificatesStatisticsRetrieveResponseSuccess)

export const getCertificatesStatisticsRetrieveUrl = () => {




  return `/api/v1/certificates/statistics/`
}

/**
 * Get detailed certificate statistics
 */
export const certificatesStatisticsRetrieve = async ( options?: RequestInit): Promise<certificatesStatisticsRetrieveResponse> => {

  return customFetch<certificatesStatisticsRetrieveResponse>(getCertificatesStatisticsRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


